import { render, staticRenderFns } from "./Jerarquias.vue?vue&type=template&id=be57d434"
import script from "./Jerarquias.vue?vue&type=script&lang=js"
export * from "./Jerarquias.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports